import React, { Component } from 'react';
import DashboardHeader from '@/components/Header/DashboardHeader';
import { Footer } from '@/components/organisms/Footer';
import styles from './Legal.module.scss';

class TermsOfService extends Component {
  render() {
    return (
      <div className={styles.legalPage}>
        <DashboardHeader />
        <div className={styles.legalContainer}>
          <article className={styles.legalCard}>
            <h1 className={styles.pageTitle}>Terms of Service</h1>
            <p className={styles.lastUpdated}>Last updated: 31 July 2026</p>

            <p className={styles.intro}>
              These Terms of Service ("Terms") govern your access to and use of the Chatup24
              platform at chatup24.com and our related mobile applications (the "Service"), operated
              by <span className={styles.entityName}>Chatup24 Global Technologies L.L.C-FZ</span>
              {' '}("Chatup24", "we", "us" or "our"), a free-zone company registered in the Meydan
              Free Zone, Dubai, United Arab Emirates (Trade License No. 2651661.01). Please read
              these Terms carefully.
            </p>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>1. Acceptance of These Terms</h2>
              <p className={styles.paragraph}>
                By accessing or using the Service, you agree to be bound by these Terms. If you do
                not agree, you must not use the Service.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>2. Description of the Service</h2>
              <p className={styles.paragraph}>
                Chatup24 is a platform that connects customers with venues such as bars, restaurants,
                salons, hotels and grocery stores, allowing you to call staff, place orders, chat,
                make bookings and pay. Chatup24 provides the technology that facilitates these
                interactions. The venue (organizer) you interact with — not Chatup24 — is responsible
                for the actual goods and services provided to you, including food, drinks, products,
                appointments and bookings, as well as their quality, pricing, availability and
                fulfilment.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>3. Accounts and Eligibility</h2>
              <p className={styles.paragraph}>
                You must be at least 18 years old to use the Service. When you create an account
                (for example, via Google or phone login), you agree to provide accurate information
                and to keep your account secure. You are responsible for activity that takes place
                under your account.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>4. Acceptable Use</h2>
              <p className={styles.paragraph}>You agree not to:</p>
              <ul className={styles.list}>
                <li>Use the Service for any unlawful, fraudulent or abusive purpose.</li>
                <li>Harass, threaten or send offensive content to venue staff or others.</li>
                <li>Interfere with, disrupt or attempt to gain unauthorised access to the Service.</li>
                <li>Misuse call-staff, ordering or booking features, including placing false requests.</li>
              </ul>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>5. Orders, Bookings and Payments</h2>
              <p className={styles.paragraph}>
                When you place an order or booking through the Service, you enter into a transaction
                with the relevant venue. Prices, availability and terms of sale are set by the venue.
                Depending on the venue, you may pay online through our payment gateway or settle
                directly at the venue. Online card payments are processed securely by our third-party
                payment providers. Any refunds, cancellations or disputes relating to goods or
                services are handled by the venue in accordance with its own policies.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>6. User Content</h2>
              <p className={styles.paragraph}>
                You are responsible for the content you submit through the Service, including chat
                messages and requests. You must not submit content that is unlawful, infringing or
                harmful. By submitting content, you grant us a limited licence to use it as necessary
                to operate and provide the Service.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>7. Intellectual Property</h2>
              <p className={styles.paragraph}>
                The Service, including its software, design, logos and content (excluding user
                content and venue content), is owned by Chatup24 or its licensors and is protected by
                applicable laws. You may not copy, modify, distribute or create derivative works
                without our prior written permission.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>8. Disclaimers and Limitation of Liability</h2>
              <p className={styles.paragraph}>
                The Service is provided on an "as is" and "as available" basis. To the fullest extent
                permitted by law, we disclaim all warranties, express or implied. Chatup24 is not
                responsible for the goods or services provided by venues, and we do not guarantee that
                the Service will be uninterrupted or error-free. To the maximum extent permitted by
                law, Chatup24 shall not be liable for any indirect, incidental or consequential
                damages arising from your use of the Service.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>9. Indemnity</h2>
              <p className={styles.paragraph}>
                You agree to indemnify and hold harmless Chatup24 and its affiliates from any claims,
                losses or expenses arising out of your misuse of the Service or your breach of these
                Terms.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>10. Suspension and Termination</h2>
              <p className={styles.paragraph}>
                We may suspend or terminate your access to the Service at any time if you breach these
                Terms or misuse the Service. You may stop using the Service and close your account at
                any time.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>11. Governing Law and Jurisdiction</h2>
              <p className={styles.paragraph}>
                These Terms are governed by the laws of the United Arab Emirates and the applicable
                regulations of the Meydan Free Zone. Any dispute arising out of or in connection with
                these Terms shall be subject to the exclusive jurisdiction of the competent courts and
                authorities of Dubai, United Arab Emirates.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>12. Changes to These Terms</h2>
              <p className={styles.paragraph}>
                We may update these Terms from time to time. When we do, we will revise the "Last
                updated" date above. Your continued use of the Service after changes take effect
                constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>13. Contact Us</h2>
              <p className={styles.paragraph}>If you have questions about these Terms, contact us at:</p>
              <div className={styles.contactBlock}>
                <p className={styles.entityName}>Chatup24 Global Technologies L.L.C-FZ</p>
                <p>Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.</p>
                <p>Email: <a className={styles.link} href="mailto:privacy@chatup24.com">privacy@chatup24.com</a></p>
              </div>
            </section>
          </article>
        </div>
        <Footer />
      </div>
    );
  }
}

export default TermsOfService;
